import { config } from '../config';
import type { PokemonRecord } from '../types';

export function buildPokedexSpeech(pokemon: PokemonRecord): string {
  const fields = {
    nameZh: pokemon.nameZh,
    categoryZh: pokemon.categoryZh,
    descriptionZh: pokemon.descriptionZh,
  };

  return config.speech.fields
    .map((field) => fields[field as keyof typeof fields] ?? '')
    .map((part) => part.trim().replace(/[。！？!?]+$/u, ''))
    .filter(Boolean)
    .join(config.speech.separator)
    .concat('。');
}

export function speakPokemon(pokemon: PokemonRecord): void {
  if (!config.speech.enabled || !('speechSynthesis' in window)) return;
  if (config.speech.cancelPrevious) window.speechSynthesis.cancel();

  const utterance = new SpeechSynthesisUtterance(buildPokedexSpeech(pokemon));
  utterance.lang = config.speech.lang;
  utterance.rate = config.speech.rate;
  utterance.pitch = config.speech.pitch;
  utterance.volume = config.speech.volume;

  const voices = window.speechSynthesis.getVoices();
  const chineseVoices = voices.filter((voice) => voice.lang.toLowerCase().startsWith('zh'));
  const preferredMale = config.speech.preferredMaleVoiceKeywords.map((value) => value.toLowerCase());
  const preferred = config.speech.preferredVoiceKeywords.map((value) => value.toLowerCase());
  utterance.voice =
    findVoice(chineseVoices, preferredMale) ??
    findVoice(chineseVoices, preferred) ??
    voices.find((voice) => voice.lang.toLowerCase() === config.speech.lang.toLowerCase()) ??
    chineseVoices[0] ??
    null;

  window.speechSynthesis.speak(utterance);
}

export function stopSpeech(): void {
  if ('speechSynthesis' in window) window.speechSynthesis.cancel();
}

function findVoice(voices: SpeechSynthesisVoice[], keywords: string[]): SpeechSynthesisVoice | undefined {
  return voices.find((voice) => {
    const searchable = `${voice.name} ${voice.voiceURI}`.toLowerCase();
    return keywords.some((keyword) => searchable.includes(keyword));
  });
}
